import { render, staticRenderFns } from "./PedidoItemTable.vue?vue&type=template&id=426eb4fe"
import script from "./PedidoItemTable.vue?vue&type=script&lang=js"
export * from "./PedidoItemTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports